<div class="container-fluid" #divLoginPage>
  <div class="row mh-100vh">
    <div class="col-10 col-sm-8 col-md-6 col-lg-6 offset-1 offset-sm-2 offset-md-3 offset-lg-0 align-self-center d-lg-flex align-items-lg-center align-self-lg-stretch bg-white p-5 rounded rounded-lg-0 my-5 my-lg-0" id="login-block">
      <div class="m-auto register-login w-lg-75 w-xl-50">
        <div class="text-center mb-5"><img src="/assets/images/CFN-LOGO-Validated.svg" style="width: 185px;"></div>
        <h2 style="font-size: 14px;line-height: 1.5;margin: 20px auto;"><br>Sélectionner un moyen pour recevoir le code d'authentification à deux facteurs :</h2>
        <form [formGroup]="sendCodeForm" (ngSubmit)="sendCode()" action="#" novalidate>
          <div class="row">
            <div class="col">

            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4" *ngFor="let p of providers">
            <div class="input-group form-group remember-me-container">
              <div class="input-group-prepend">
                <p-radioButton formControlName="factor" name="factor" value="{{p.Name}}"></p-radioButton>
              </div>
              <span class="remember-me-label">{{p.DisplayedValue}}</span>
            </div>
          </div>
          <div class="row alert alert-info" *ngIf="selectedProvider != null && infoMessage != null">
            {{infoMessage}}.
          </div>
          <button class="btn btn-primary btn-block" type="button" style="margin-top: 10px;" (click)="sendCode()">
            <span class="btn-label">
              <i class="pi pi-unlock text-white"></i>
            </span>
            Envoyer
          </button>
        </form>
      </div>
    </div>
    <div class="col-lg-6 d-flex align-items-end login-bg" id="bg-block">
      <div></div>
    </div>
  </div>
</div>
